var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19,
    r: 18.2016,
    fill: "white",
    stroke: "#DADADA",
    strokeWidth: 0.596774
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.645 27.91L17.638 27.907L17.616 27.895C17.4873 27.8242 17.3596 27.7515 17.233 27.677C15.7108 26.7725 14.2883 25.7099 12.989 24.507C10.688 22.36 8.25 19.174 8.25 15.25C8.25 12.322 10.714 10 13.688 10C14.5148 9.99595 15.3318 10.1783 16.0783 10.5336C16.8249 10.8889 17.4817 11.4079 18 12.052C18.5184 11.4077 19.1754 10.8887 19.9221 10.5334C20.6689 10.1781 21.4861 9.9958 22.313 10C25.286 10 27.75 12.322 27.75 15.25C27.75 19.175 25.312 22.361 23.011 24.506C21.7117 25.709 20.2892 26.7715 18.767 27.676C18.6404 27.7508 18.5127 27.8238 18.384 27.895L18.362 27.907L18.355 27.911L18.352 27.912C18.2436 27.9694 18.1227 27.9995 18 27.9995C17.8773 27.9995 17.7564 27.9694 17.648 27.912L17.645 27.91Z",
    fill: "#BC172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.a829e652f80432a7586361427c8c810b.svg";
export { ForwardRef as ReactComponent };